import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  useEffect(() => {
    // Add loaded class for animations
    document.body.classList.add('loaded');
  }, []);

  return (
    <footer className="footer">
      <div className="container">
        {/* Sección Principal */}
        <div className="footer-grid">
          {/* Columna 1: Información de la Empresa */}
          <div className="footer-column company-info" style={{'--index': 0}}>
            <h3 className="footer-title">Rêver</h3>
            <p className="company-description">
              Empresa mexicana fundada en 2022, especializada en soluciones industriales 
              para los sectores de Minería, Energía y Oil & Gas. Nos enfocamos en la innovación 
              tecnológica, la eficiencia operativa y la seguridad industrial, ofreciendo 
              soluciones personalizadas que optimizan los procesos y reducen costos.
            </p>
            <p className="company-mission">Comprometidos con la sostenibilidad y el futuro de la industria.</p>
          </div>
          
          {/* Columna 2: Navegación */}
          <div className="footer-column navigation" style={{'--index': 1}}>
            <h3 className="footer-title">Enlaces</h3>
            <nav className="footer-nav">
              <Link to="/quienes-somos" className="footer-link">¿Quiénes Somos?</Link>
              <Link to="/proyectos" className="footer-link">Proyectos</Link>
              <Link to="/negocios" className="footer-link">Servicios</Link>
              <Link to="/contacto" className="footer-link">Contacto</Link>
            </nav>
            <div className="logo-container">
              <img src="/assets/icono_R.png" alt="Logo Rêver" className="logo-footer" />
            </div>
          </div>
          
          {/* Columna 3: Contacto */}
          <div className="footer-column contact" style={{'--index': 2}}>
            <h3 className="footer-title">Contacto</h3>
            <div className="social-links">
              {/* <a href="https://linkedin.com/company/rever" target="_blank" rel="noopener noreferrer" className="social-link">LinkedIn</a>
              <a href="https://twitter.com/rever" target="_blank" rel="noopener noreferrer" className="social-link">Twitter</a>
              <a href="https://instagram.com/rever" target="_blank" rel="noopener noreferrer" className="social-link">Instagram</a> */}
              <a href="mailto:lsanchez@reverlat.com" target="_blank" rel="noopener noreferrer" className="social-link">E-Mail</a>

            </div>
          </div>
        </div>
        
        {/* Línea divisoria */}
        <div className="footer-divider"></div>
        
        {/* Sección de créditos */}
        <div className="credits-section">
          <div className="copyright">
            <p>© 2025 Rêver. Todos los derechos reservados.</p>
          </div>
          <div className="developer-info">
            <p>
              Developed on <strong>planet earth</strong> by 
              <a href="https://arnolsegovia.com" target="_blank" rel="noopener noreferrer" className="developer-link">
                ✶<img src="/assets/atlante.png" alt="Logo Atlante" className="logo-credits" />
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;